module.exports = __webpack_public_path__ + "img/logo_v2_white.3f267135.png";